import { render, staticRenderFns } from "./YoutubeSwiper.vue?vue&type=template&id=1ae906f6&scoped=true&"
import script from "./YoutubeSwiper.vue?vue&type=script&lang=js&"
export * from "./YoutubeSwiper.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeSwiper.vue?vue&type=style&index=0&id=1ae906f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae906f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
